import Vue from 'vue';
import Router from 'vue-router';
import { routes } from './routes';
import store from "@/store/store";

// 使用Router
Vue.use(Router)

// 配置路由
const RouterConfig = {
  mode:"history",
  base: process.env.BASE_URL,   // 添加base解决
  routes:routes
}

// 创建VueRouter 实例
export const router = new Router(RouterConfig)

// 解决Vue跳转当前页面报错
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

/**
 * to 下一个页面
 * from 从那个页面来
 * next 到哪里去
 */
router.beforeEach((to, from, next) => {
  // console.log("to", to)
  console.log('是否登录： ', Vue.prototype.fungetLogin(), '是否需要判断登录', to.meta.login);

  if(Vue.prototype.fungetLogin()){
    let oldTime = JSON.parse(localStorage.getItem('isLogin')).time;
    let newTime = new Date().getTime();
    
    // 登录时效默认 一天
    if (!oldTime || (newTime - oldTime) > 1000 * 60 * 60 * 24 * 1){
      localStorage.getItem("loginParam") ? Vue.prototype.handleExitLogin() : ''; // 登录超时，删除登录信息
    }

    console.log('存在登录，更新登录时效');
    localStorage.setItem("isLogin", JSON.stringify({
      isLogin: true,
      time: new Date().getTime(),
    }));
  }


  // 无需判断登录，直接可以跳转
  if(!to.meta.login || to.meta.login && Vue.prototype.fungetLogin()){
    to.meta.noUrl ? "" : next();
  }else{
    // 未登录
    console.log('登录后才可以看账户中心');
    next({path: from.fullPath, query:{ Rurl: to.fullPath} });
    Vue.prototype.showLoginPopus();
  }
})

router.afterEach((to,from,next) => {
  window.scrollTo(0,0); // 滚动到顶部
  // 或
  // window.scroll(0, 0);
});



// WEBPACK FOOTER //
// ./src/router/index.js